import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import sumBy from 'lodash/sumBy'
import styled from 'styled-components'
import { Row, Cell } from 'react-sticky-table'

import { FONTS } from '../../../../../constants'
import { formatNumber, subtract } from '../../../../../function/math.js'

const sumByLOB = (month, lob, revenueAllocation) => {
  let sum = 0
  revenueAllocation.map(r => {
    r.lobs.map(l => {
      if (lob === '' || l.lob_id === lob) {
        sum += sumBy(l.lob_months, m => {
          if (moment(m.month).isSame(month, 'month')) return numeral(m.revenue).value()
          return 0
        })
      }
      return l
    })
    return r
  })
  return sum
}

// const sumTotalTypeRev = (revenueAllocation) => {
//   return sumBy(revenueAllocation, r => {
//     return numeral(r._sumTotalTypeRev).value()
//   })
// }

export const renderHeader = (monthList, revenueAllocation, selectedLOB) => {
  const { _sumProjectRevenue, _sumAllocationRevenue } = revenueAllocation

  return (
    <Row>
      <StickyWrapper>
        <Wrapper>
          <Cell>
            <ProjectCol>
              <StickyText>Project Revenue</StickyText>
              <StickyNumber>{`฿ ${formatNumber(_sumProjectRevenue)}`}</StickyNumber>
            </ProjectCol>
          </Cell>
          <Cell>
            <AvailableCol>
              <StickyText>Available</StickyText>
              <StickyNumber>
                {`฿ ${subtract(_sumProjectRevenue, _sumAllocationRevenue)}`}
              </StickyNumber>
            </AvailableCol>
          </Cell>
        </Wrapper>
        <HeaderCol>
          <HeaderText>Total Type Rev</HeaderText>
          <HeaderNumber>{`฿ ${formatNumber(_sumAllocationRevenue)}`}</HeaderNumber>
        </HeaderCol>
      </StickyWrapper>
      <Wrapper>
        <Wrapper>
          { monthList.map(i => {
            const sum = sumByLOB(i, selectedLOB.value, revenueAllocation)
            return (
              <MonthRow key={ i }>
                <HeaderText>{ moment(i).format('MMM YYYY') }</HeaderText>
                <HeaderNumber>{`฿ ${formatNumber(sum)}`}</HeaderNumber>
              </MonthRow>
            )
          })}
        </Wrapper>
        { monthList.length < 10 &&
        Array.from({ length: 10 - monthList.length }, (v, i) => i).map(i => (
          <MonthRow key={ i }>
            <HeaderText />
            <HeaderNumber />
          </MonthRow>
        ))}
      </Wrapper>
    </Row>
  )
}

const StickyWrapper = styled.div`
  width: 600px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
`

const Wrapper = styled.div`
  display: flex;
`

const ProjectCol = styled.div`
  width: 150px;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 6px 0 24px;
  background: rgba(0, 0, 0, 0.8);
`

const AvailableCol = styled.div`
  width: 310px;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 6px;
  background: rgba(0, 0, 0, 0.8);
`

const StickyText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

const StickyNumber = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: 12px;
  color: #FFFFFF;
`

const MonthRow = styled.div`
  width: 125px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.6);
  padding: 0 5px;

  :nth-child(1) {
    padding: 0 5px 0 10px;
  }

  :nth-last-child(1) {
    padding: 0 10px 0 5px;
  }
`

const HeaderCol = styled.div`
  width: 140px;
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: none;
  border-bottom: none;
  padding: 0 10px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

const HeaderNumber = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: 12px;
  color: #FFFFFF;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/header.js